// extracted by mini-css-extract-plugin
module.exports = {"list":"LanguagePanel_list__EecjG"};